<script setup lang="ts">

import {computed} from "vue";

const props = defineProps({
  height: {
    type: [String, Number],
    default: '100px'
  }
})

const height = computed(() => props.height)

const loaderStyle = computed(() => {
  return {height: height.value, width: height.value};
})
</script>

<template>
  <div class="loading-indicator" :style="loaderStyle"></div>
</template>

<style scoped lang="less">
.loading-indicator--wrapper {
  display: inline-block;;
}
.loading-indicator {
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 2px solid #eaf3f8;
  border-right: 2px solid #eaf3f8;
  border-bottom: 2px solid #eaf3f8;
  border-left: 2px solid #80bd1c;
  transform: translateZ(0);
  animation: load8 0.8s infinite linear;

  border-radius: 50%;
  width: 100%;
  height: 100%;

  &:after {
    border-radius: 50%;
    width: 100%;
    height: 100%;
  }
}
</style>
